:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
}

:host([data-is-visible]) {
  display: block;
}

.hidden {
  display: none;
}

.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  .form-wrapper {
    box-sizing: border-box;
    min-width: 500px;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    padding: 32px calc(4 * var(--spacer)) 0;
  }
}

.bottom-buttons {
  flex-basis: 55px;
  min-height: 55px;
  margin-top: auto;
  display: flex;
  align-items: center;

  border-top: 1px solid var(--chart-101-pressed-dividers);
  padding: 0 calc(4 * var(--spacer));
}
